import router from "@/router";
import { generateRoutes } from "@/router/permission";

<template>
  <div class="login">

    <!-- 左侧登录区域 -->
    <div class="login-left">

      <div class="login-box">

        <!-- Logo -->
<!--        <div class="logo-area">

          <img
              src="@/assets/logo.png"
              class="logo"
          />

          <span>
            .
          </span>

        </div>-->

        <h1>
          {{ $t('loginPage.title') }}
        </h1>

        <p class="desc">
<!--          Welcome back to your special place-->
        </p>


        <el-form ref="loginReqVO" :model="loginReqVO" :rules="rules">
          <!-- 商户号 -->
          <el-form-item prop="strMaMerNo">

            <el-input v-model="loginReqVO.strMaMerNo"

                :placeholder="$t('loginPage.merNo')"

                prefix-icon="el-icon-bank-card"
            />

          </el-form-item>



          <!-- 用户名 -->

          <el-form-item prop="maMerLgginAccount">

            <el-input v-model="loginReqVO.maMerLgginAccount"
                      :placeholder="$t('loginPage.accountPlaceholder')"

                prefix-icon="el-icon-user"

            />


          </el-form-item>


          <!-- 密码 -->

          <el-form-item prop="maLoginPwd">

            <el-input v-model="loginReqVO.maLoginPwd" type="password"
                show-password

                :placeholder="$t('loginPage.passwordPlaceholder')"

                prefix-icon="el-icon-lock"

            />


          </el-form-item>


          <!-- 验证码 -->

          <el-form-item prop="captcha">

            <div class="captcha-box">

              <el-input v-model="loginReqVO.captcha" :placeholder="$t('loginPage.captchaPlaceholder')"

                  prefix-icon="el-icon-key"

                  @keyup.enter.native="submitForm('loginReqVO')"

              />


              <div
                  class="captcha_img_box"
                  @click="getCaptcha"
              >

                <img
                    v-if="captchaUrl"
                    :src="captchaUrl"
                />

              </div>


            </div>

          </el-form-item>


          <div class="login-options">

<!--            <el-checkbox>

              Remember me

            </el-checkbox>


            <span>
              Forgot Password?
            </span>-->


          </div>

          <el-button class="login-btn" :loading="loginLoading"

              @click="submitForm('loginReqVO')"

          >

            {{ $t('loginPage.submitBtn') }}


          </el-button>



        </el-form>



<!--        <div class="footer-text">

          Secure payment platform

        </div>-->


      </div>



      <!-- 语言切换 -->

<!--      <div class="lang-switcher">

        <el-dropdown @command="changeLang">
        <span>
          <i class="fa fa-language"></i>
          {{currentLang==='zh-CN'
            ?'中文'
            :'English'}}

        </span>


          <el-dropdown-menu slot="dropdown">

            <el-dropdown-item command="zh-CN">
              中文
            </el-dropdown-item>


            <el-dropdown-item command="en-US">
              English
            </el-dropdown-item>


          </el-dropdown-menu>


        </el-dropdown>



      </div>-->


    </div>





    <!-- 右侧图片区域 -->

    <div class="login-right">

      <!-- 语言切换 -->
      <div class="lang-switcher">

        <el-dropdown
            @command="changeLang"
        >

      <span>

        <i class="fa fa-language"></i>

        {{currentLang==='zh-CN'
          ?'中文'
          :'English'}}

      </span>


          <el-dropdown-menu slot="dropdown">

            <el-dropdown-item command="zh-CN">
              中文
            </el-dropdown-item>


            <el-dropdown-item command="en-US">
              English
            </el-dropdown-item>

          </el-dropdown-menu>


        </el-dropdown>


      </div>

    </div>



  </div>
</template>

<script>
import router from "@/router";
import { generateRoutes } from "@/router/permission";

export default {
  data() {
    return {
      logo_url: require("@/assets/logo.png"),
      loginReqVO: {
        strMaMerNo:"",
        maMerLgginAccount: "",
        maLoginPwd: "",
        captcha: "", // 验证码输入值
        captchaUuid:"",
      },
      captchaUrl: "", // 验证码图片地址 (Base64 或 URL)

      loginLoading: false,

    };
  },
  computed: {
    // 获取当前语言，用于显示在右上角
    currentLang() {
      return this.$i18n.locale;
    },
    // 将 rules 放在 computed 中，这样当 $t 变化时，规则会重新计算
    rules() {
      return {
        strMaMerNo: [
          { required: true, message: this.$t('loginPage.merNo'), trigger: "blur" }
        ],
        maMerLgginAccount: [
          { required: true, message: this.$t('loginPage.accountRequired'), trigger: "blur" }
        ],
        maLoginPwd: [
          { required: true, message: this.$t('loginPage.passwordRequired'), trigger: "blur" }
        ],
        captcha: [
          { required: true, message: this.$t('loginPage.captchaPlaceholder'), trigger: "blur" }
        ]
      };
    }
  },
  created() {
    // 页面加载时读取保存的语言配置
    const lang = localStorage.getItem('lang');
    if (lang) {
      this.$i18n.locale = lang;
    }
    // 从 localStorage 中读取账号和密码
    const storedUsername = localStorage.getItem("name");
    const storedPassword = localStorage.getItem("password");

   /* if (storedUsername && storedPassword) {
      // 填充账号和密码
      this.ruleForm.name = storedUsername;
      this.ruleForm.password = storedPassword;
    }*/
    // 页面加载时获取验证码
    this.getCaptcha();
  },
  methods: {
    // 切换语言方法
    changeLang(command) {
      this.$i18n.locale = command;
      localStorage.setItem('lang', command); // 记住用户选择的语言
      // 切换语言后清除可能存在的表单验证报错信息，提升体验
      if (this.$refs.loginReqVO) {
        this.$refs.loginReqVO.clearValidate();
      }
    },

    // 获取验证码
    getCaptcha() {
      this.$axios
        .get("/api/meradmin/getVerify")
        .then((res) => {
          if (res.data && res.data.code == "0") {
            this.captchaUrl = res.data.data.img;
            this.loginReqVO.captchaUuid = res.data.data.uuid;
          }
        })
        .catch((err) => {
          console.error("验证码获取失败，已启用 Mock 兜底", err);
        });
    },

    // 登录
    submitForm(formName) {

     /* const isTestMode = true; //
      if (isTestMode) {
        const user = { name: "admin" };
        sessionStorage.setItem("user", JSON.stringify(user));
        sessionStorage.setItem("token", "mock_token_for_test"); // 模拟 token
        //this.$router.push("/order/listPage");
        this.$router.push("/dashboard/index");
        return;
      }*/


      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loginLoading = true;
          this.$axios
            .post("/api/meradmin/login", this.loginReqVO)
            .then((res) => {

              if (res.data.code == "0") {
                sessionStorage.setItem("user", res.data.data.maMerLgginAccount);
                // 申请退款是否复核
                sessionStorage.setItem("refundIsCheck", res.data.data.refundIsCheck);
                // 是否显示人民币
                sessionStorage.setItem("isShowCny", res.data.data.isShowCny);

                // 是否默认管理员
                sessionStorage.setItem("maIsDefault", res.data.data.maIsDefault);

                // 是否显示渣打
                sessionStorage.setItem("merDisplayScb", res.data.data.merDisplayScb);

                sessionStorage.setItem("token", res.data.data.token);

                sessionStorage.setItem("menus", JSON.stringify(res.data.data.menus));

                // 生成动态路由
                const routes = generateRoutes(
                  res.data.data.menus
                );
                //console.log("动态路由", routes);
                routes.forEach(route => {
                  router.addRoute("home", route);
                 // console.log("注册路由", route);

                });

                const buttonMap =
                  buildButtonMap(res.data.data.menus);

                sessionStorage.setItem(
                  "buttonMap",
                  JSON.stringify(buttonMap)
                );



                //this.$router.push("/dashboard/index");
                this.$router.push("/home/dashboard/Index");
              } else {
                this.getCaptcha();
                console.log(1, res.data);
                this.$message.error(res.data.msg);
                this.loginLoading = false;


              }
            })
            .catch((err) => {
              this.getCaptcha();
              this.$message.error(this.$t('loginPage.serverError'));
              this.loginLoading = false;
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },


    resetForm(formName) {
      this.$refs[formName].resetFields();
    },


  },
};
function buildButtonMap(menus) {

  const map = {};

  function loop(list) {

    list.forEach(item => {

      if (
        item.type === "menu" &&
        item.path
      ) {

        const buttons = [];

        if (
          item.children &&
          item.children.length
        ) {

          item.children.forEach(child => {

            if (
              child.type === "button"
            ) {

              buttons.push(
                child.perms
              );

            }

          });

        }

        map[item.path] = buttons;

      }

      if (
        item.children &&
        item.children.length
      ) {

        loop(item.children);

      }

    });

  }

  loop(menus);

  return map;

}

</script>

<style>
html,
body,
#app{
  width:100%;
  height:100%;
  margin:0;
  padding:0;
  overflow:hidden;
}
</style>


<style scoped>



.login{

  width:100%;

  height:100vh;

  display:flex;

  overflow:hidden;

}



/* ===================
 左边
=================== */


.login-left{


 /* width:50%;*/
  width:66.666%;

  position:relative;


  display:flex;

  justify-content:center;

  align-items:center;


}



.login-box{

  width:380px;



}



.logo-area{


  display:flex;

  align-items:center;

  gap:10px;


  font-weight:bold;

  font-size:18px;


}



.logo{


  width:28px;

  height:28px;


}



h1{


  font-size:36px;
  font-weight:700;

  margin-top:35px;

  line-height:1.2;


  margin-bottom:10px;


  color:#111;


}




.desc{


  color:#888;

  margin-bottom:40px;


}




/* 输入框 */

.el-input{
  height:40px;
}


.el-input__inner{
  height:40px;
  line-height:40px;
  font-size:14px;
}


.el-form-item{
  margin-bottom:16px;
}

::v-deep .el-form-item__content {

  line-height:40px;

}


/* 验证码 */


.captcha-box{


  display:flex;

  gap:10px;

  width:100%;


}



.captcha-box .el-input{


  flex:1;


}



/* 验证码图片 */
.captcha_img_box {

  width:110px;


  flex-shrink:0;
  background: #fff;

  border:1px solid #dcdfe6;

  border-radius:10px;

  overflow:hidden;

  cursor:pointer;

  display:flex;

  align-items:center;

  justify-content:center;

  background:#f8fafc;

}
.captcha-box{
  display:flex;
  gap:10px;
  width:100%;
  align-items: stretch;
}

.captcha_img_box img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* hover效果 */
.captcha_img_box:hover {
  border-color: #154ec1;
}




.login-options{


  display:flex;

  justify-content:space-between;


  font-size:13px;


  margin:10px 0 30px;


  color:#666;


}




.login-btn{

  width:110px;

  height:40px;

  font-size:16px;


  border-radius:8px;


  background:#7138ff;


  border:none;


  color:white;


}



.login-btn:hover{


  background:#824cff;


}




.footer-text{


  margin-top:70px;


  font-size:12px;


  color:#aaa;


}



/* 语言 */

.lang-switcher{


  position:absolute;


  top:30px;

  right:40px;


}
.lang-switcher span{

  display:flex;

  align-items:center;

  gap:8px;


  padding:10px 18px;

  border-radius:20px;

  background:#fff;

  border:1px solid #eee;


  cursor:pointer;

  color:#555;


  box-shadow:0 4px 12px rgba(0,0,0,.08);

}


.lang-switcher span:hover{

  color:#7138ff;

}





/* ===================
 右边图片
=================== */


.login-right{


  width:50%;
/*  width:33.333%;*/


  height:60vh;


  margin:200px 12px;


  border-radius:25px;


  overflow:hidden;


  background-image: url(~@/assets/login/login-security.png);

  background-repeat:no-repeat;


  background-position:center;


  background-size:cover;


}




.login-image{


  width:90%;


  max-width:650px;


  animation:

      float 5s infinite alternate;


}





@keyframes float{


  from{


    transform:translateY(0);


  }


  to{


    transform:translateY(-20px);


  }



}




/* 手机适配 */

@media(max-width:900px){


  .login-right{

    display:none;

  }


  .login-left{

    width:100%;

  }


}



</style>



// WEBPACK FOOTER //
// src/view/Login.vue